import initCollapsibles from './components/collapsible'
import initMenuAnimations from './components/menuAnimations'
import initFooterAnimations from './components/footerAnimations'
import initMobileMenu from './components/mobileMenu'
import initModal from './components/modal'
import initEmblaCarousel from './components/emblaCarousel'
import initHomeSecondaryNavigation from './components/sidebarNavigation'
import initSmoothScroll from './components/smoothScroll'

// Initialize dropdowns
document.addEventListener('DOMContentLoaded', () => {
  initCollapsibles();
  initHomeSecondaryNavigation();
  initMenuAnimations();
  initFooterAnimations();
  initMobileMenu();
  initModal();
  initEmblaCarousel();
  initSmoothScroll();
});